import React from "react";
import { Card } from "reactstrap";
import { Box, HelpCircle, TrendingUp, TrendingDown } from "react-feather";
import LineChart from "../../../components/charts/lineChart";

interface IProductStatCardProps {
    title: string;
    count: number;
    comparisonText: string;
    percentageChange: number;
    data: number[];
    type: "active" | "concept";
    loading?: boolean;
}

const ProductStatCard: React.FC<IProductStatCardProps> = ({
    title,
    count,
    comparisonText,
    percentageChange,
    data,
    type,
    loading
}) => {
    const isPositive = percentageChange >= 0;
    const cardColor = type === "active" ? "#2460D8" : "#E88D16";

    const chartData = {
        labels: data.map((_, i) => i.toString()),
        datasets: [
            {
                label: title,
                data: data,
                fill: true,
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                borderColor: "rgba(255, 255, 255, 0.8)",
                borderWidth: 2,
                pointRadius: 0,
                lineTension: 0.4
            }
        ]
    };

    return (
        <Card
            className={`product-stat-card border-0 h-100 ${type}-card`}
            style={{ backgroundColor: cardColor, color: "#fff" }}
        >
            <div className="card-content-wrapper p-4 d-flex flex-column position-relative overflow-hidden h-100">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center">
                        <div className="icon-bg mr-2">
                            {type === "active" ? <Box size={16} /> : <HelpCircle size={16} />}
                        </div>
                        <span className="font-weight-bold small text-uppercase" style={{ opacity: 0.9 }}>
                            {title}
                        </span>
                        <HelpCircle size={14} className="ml-1" style={{ opacity: 0.6 }} />
                    </div>
                </div>

                {/* Content */}
                <div className="card-content-main mb-2">
                    <div className="d-flex align-items-center mb-1">
                        <h1 className="display-4 font-weight-bold mb-0 mr-3" style={{ fontSize: "2.5rem" }}>{count.toLocaleString()}</h1>
                        <div className={`change-indicator d-flex align-items-center px-2 py-1 rounded ${isPositive ? "positive" : "negative"}`}>
                            {isPositive ? <TrendingUp size={14} className="mr-1" /> : <TrendingDown size={14} className="mr-1" />}
                            <span className="small font-weight-bold">{isPositive ? "+" : ""}{percentageChange}%</span>
                        </div>
                    </div>
                    <div className="small" style={{ opacity: 0.8 }}>{comparisonText}</div>
                </div>

                {/* Sparkline Chart */}
                <div className="sparkline-container mt-auto" style={{ height: "120px", marginLeft: "-24px", marginRight: "-24px", marginBottom: "-24px" }}>
                    <LineChart
                        data={chartData}
                        hideAxes={true}
                        noGridLines={true}
                        color="#fff"
                    />
                </div>
            </div>
        </Card>
    );
};

export default ProductStatCard;
